export const convertProjectsSnapshotToMap = objsSnapshot => {
    const transformedObjs = objsSnapshot.docs.map(doc=>{
      return{
        id: doc.id,
        ...doc.data()
      };  
    })
    return transformedObjs;
  };